import "./Mixes.scss";

import config from "../../../config";

import React from "react";
import { inject, observer } from "mobx-react";
import { RouteNode } from "react-router5";

import Frame from "../Frame/Frame";
import PagerAmount from "../../Components/Pager/PagerAmount";
import Pager from "../../Components/Pager/Pager";
import Popup from "../../Components/Popup/Popup";
import RefreshButton from "../../Components/RefreshButton/RefreshButton";
import { STORE_CONFIG } from "../../Store/ConfigStore";
import { ROUTE_MIXES, ROUTE_MIX } from "../../routes";
import { STORE_MIXES, SORT_ASC, SORT_DESC } from "../../Store/MixesStore";
import { STORE_AUTH } from "../../Store/AuthStore";
import axios from "axios";
import DatePicker, { registerLocale } from "react-datepicker";
import hu from "date-fns/locale/hu";
registerLocale("hu", hu);
import { formatDate, formatDateOnly } from "../../utility";
import { timeout } from "q";
import XLSX from "xlsx";

import Select from "react-select";
import { SelectStyle, DropdownIndicator } from "../App/select_style";

const SORT_ID = "Id";
const SORT_MACHINE = "Machine";
const SORT_CLEANINGRATE = "CleaningRateText";
const SORT_SUPPLIER = "Supplier";
const SORT_LOTNO = "LotNo";
const SORT_ITEM = "ItemName";
const SORT_LOCATION = "BinCode";
const SORT_AMOUNT = "Quantity";
const SORT_QPURITY = "Purity";
const SORT_QALIENSEED = "Alienseed";
const SORT_QHARDSEED = "Hardseed";
const SORT_QGERM = "Germ";
const SORT_QWATER = "Water";
const SORT_CREATED = "Created";
const SORT_TERMINATED = "Terminated";
const SORT_STATUS = "Status";

function Sorter(props) {
  const asc = ["sorter__dir sorter__dir-asc"];
  const desc = ["sorter__dir sorter__dir-desc"];
  if (props.activeDirection === SORT_ASC) {
    asc.push("sorter__dir--active");
  } else if (props.activeDirection === SORT_DESC) {
    desc.push("sorter__dir--active");
  }
  return (
    <div
      className={"sorter" + (props.activeDirection ? " sorter--active" : "")}
    >
      <div className={asc.join(" ")} title="rendezés növekvő sorrendbe" />
      <div className={desc.join(" ")} title="rendezés csökkenő sorrendbe" />
    </div>
  );
}

const TableSearch = inject((stores) => ({
  store: stores.store.get(STORE_MIXES),
}))(
  observer((props) => {
    const { store } = props;
    const cancelClassname =
      "search-cancel-button" + (store.searchtext.length > 0 ? "" : " hidden");
    return (
      <div className="table-search wide">
        <div className="table-search__label">Keresés</div>
        {/*<div className="table-search__input-container">      
        <input className="form-input form-input--inline" type="text" name="focus" value={store.search} onChange={e => store.setSearch(e.target.value)} />       
    </div>*/}
        <div className="search-wrapper wide">
          <input
            className="search-input"
            value={store.searchtext}
            onChange={(e) => store.setSearchText(e.target.value)}
          />
          <div
            className={cancelClassname}
            onClick={(e) => {
              store.setSearchText("");
              store.setSearch();
            }}
          >
            <i className="fas fa-times"></i>
          </div>
        </div>
        <div
          className="btn searchbutton"
          onClick={(e) => {
            store.setSearch(store.searchtext);
          }}
        >
          Keres
        </div>
      </div>
    );
  })
);

@inject((stores) => ({
  store: stores.store.get(STORE_MIXES),
  configStore: stores.store.get(STORE_CONFIG),
  authStore: stores.store.get(STORE_AUTH),
  socket: stores.socket,
  router: stores.router,
}))
@observer
class Mixes extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      popup: "none",
      popupText: "",
      showTerminated: false,
      from: null,
      to: null,
      subtable: null,
    };

    const { store, route } = props;
    if (!route.params.hasOwnProperty("back")) {
      store.setSearch("");
      store.setSearchText("");
    }
    props.store.resetCheckedPallets();
    this.refresh();
  }
  onClickSort = (field) => () => {
    const { store } = this.props;
    if (store.sortField === field) {
      store.flipSortDirection();
    } else {
      store.setSortField(field);
      store.setSortDirection(SORT_ASC);
    }
  };

  onFileChange = async (e) => {
    const { store } = this.props;
    if (!e.target.files.length || store.uploading) return;
    const data = new FormData();
    data.append("file", e.target.files[0]);
    e.target.value = "";
    store.setUploading();
    try {
      const response = await axios.post(config.FILE_UPLOAD_URL(window), data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      this.setState({
        popup: "show",
        popupText: "Sikeres minőség feltöltés (" + response + " db).",
      });
    } catch (e) {
      console.error("feltöltés hiba: ", e);
      this.setState({
        popup: "show",
        popupText: "Sikertelen minőség feltöltés.",
      });
    } finally {
      store.setUploading(false);
      this.refresh();
    }
  };

  typedValue = (value) => {
    return {
      t: isNaN(value) ? "s" : "n",
      v: value,
    };
  };

  handleDownload = () => {
    const { store, configStore } = this.props;
    const { sortedItems } = store;

    const merges = [];
    let data = [
      [
        "Azonosító",
        "Gép",
        "Fok",
        "Beszállító",
        "Cikk",
        "Hely",
        "Mennyiség",
        "Összmennyiség",
        "Létrehozva",
        "Tisztaság %",
        "Hulladék %",
        "Idegenmag %",
        "Dátum",
        "Ép csíra",
        "Beteg csíra",
        "Rohadt",
        "Keménymag v. Léhamag",
        "Víz %",
        "Vad repce",
        "Repcsényretek",
        "Vadzab",
        "Aranka",
        "Rumex",
        "Tarackbúza",
        "Szklerocium",
        "Gabona",
        "Nem gabona",
        "Idegenmag darabszám",
        "Szerződés szerinti idegenmagok",
        "Egyéb adat",
        "Egyéb mag",
        "Egyéb megnevezés",
        "Vizsgálati dátum",
      ],
    ];
    if (store.showTerminated)
      data[0] = data[0].concat(["Megszüntetve", "Művelet"]);

    let rowindex = 1;

    sortedItems.forEach((pallet) => {
      let row = [
        pallet.LotNo + (pallet.SealNum ? " (" + pallet.SealNum + ")" : ""),
        pallet.MachineText,
        pallet.CleaningRateText +
          (pallet.CustomCleaningRate
            ? " (" + pallet.CustomCleaningRate + ")"
            : ""),
        (pallet.Supplier ? pallet.Supplier : "") +
          (pallet.CustomSupplier ? " (" + pallet.CustomSupplier + ")" : ""),
        pallet.ItemName +
          (pallet.CustomItem ? " (" + pallet.CustomItem + ")" : ""),
        pallet.BinCode
          ? pallet.BinCode + (pallet.Level != null ? "/" + pallet.Level : "")
          : "",
        (pallet.BagType === 2
          ? pallet.BagCount + " x " + pallet.Quantity
          : pallet.Quantity) + " kg",
        pallet.BagCount * pallet.Quantity,
        pallet.Created,
        this.typedValue(
          pallet.Purity ||
            (pallet.QualityFull
              ? pallet.QualityFull[11] !== null
                ? pallet.QualityFull[11]
                : ""
              : pallet.QualityPurity !== null
              ? pallet.QualityPurity
              : "")
        ),
        this.typedValue(
          pallet.Waste ||
            (pallet.QualityFull
              ? pallet.QualityFull[12] !== null
                ? pallet.QualityFull[12]
                : ""
              : "")
        ),
        this.typedValue(
          pallet.Alienseed ||
            (pallet.QualityFull
              ? pallet.QualityFull[13] !== null
                ? pallet.QualityFull[13]
                : ""
              : "")
        ),
        this.typedValue(
          pallet.QualityFull
            ? pallet.QualityFull[14] !== null
              ? pallet.QualityFull[14]
              : ""
            : ""
        ),
        this.typedValue(
          pallet.GermHealthy ||
            (pallet.QualityFull
              ? pallet.QualityFull[15] !== null
                ? pallet.QualityFull[15]
                : ""
              : pallet.QualityGerm !== null
              ? pallet.QualityGerm
              : "")
        ),
        this.typedValue(
          pallet.GermIll ||
            (pallet.QualityFull
              ? pallet.QualityFull[16] !== null
                ? pallet.QualityFull[16]
                : ""
              : "")
        ),
        this.typedValue(
          pallet.GermRotten ||
            (pallet.QualityFull
              ? pallet.QualityFull[17] !== null
                ? pallet.QualityFull[17]
                : ""
              : "")
        ),
        this.typedValue(
          pallet.Hardseed ||
            (pallet.QualityFull
              ? pallet.QualityFull[18] !== null
                ? pallet.QualityFull[18]
                : ""
              : "")
        ),
        this.typedValue(
          pallet.Water ||
            (pallet.QualityFull
              ? pallet.QualityFull[19] !== null
                ? pallet.QualityFull[19]
                : ""
              : pallet.QualityWater !== null
              ? pallet.QualityWater
              : "")
        ),
        this.typedValue(
          pallet.Vadrepce ||
            (pallet.QualityFull
              ? pallet.QualityFull[20] !== null
                ? pallet.QualityFull[20]
                : ""
              : "")
        ),
        this.typedValue(
          pallet.Repcsenyretek ||
            (pallet.QualityFull
              ? pallet.QualityFull[21] !== null
                ? pallet.QualityFull[21]
                : ""
              : "")
        ),
        this.typedValue(
          pallet.Vadzab ||
            (pallet.QualityFull
              ? pallet.QualityFull[22] !== null
                ? pallet.QualityFull[22]
                : ""
              : "")
        ),
        this.typedValue(
          pallet.Aranka ||
            (pallet.QualityFull
              ? pallet.QualityFull[23] !== null
                ? pallet.QualityFull[23]
                : ""
              : "")
        ),
        this.typedValue(
          pallet.Rumex ||
            (pallet.QualityFull
              ? pallet.QualityFull[24] !== null
                ? pallet.QualityFull[24]
                : ""
              : "")
        ),
        this.typedValue(
          pallet.Tarackbuza ||
            (pallet.QualityFull
              ? pallet.QualityFull[25] !== null
                ? pallet.QualityFull[25]
                : ""
              : "")
        ),
        this.typedValue(
          pallet.Szklerocium ||
            (pallet.QualityFull
              ? pallet.QualityFull[26] !== null
                ? pallet.QualityFull[26]
                : ""
              : "")
        ),
        this.typedValue(
          pallet.Gabona ||
            (pallet.QualityFull
              ? pallet.QualityFull[27] !== null
                ? pallet.QualityFull[27]
                : ""
              : "")
        ),
        this.typedValue(
          pallet.Nemgabona ||
            (pallet.QualityFull
              ? pallet.QualityFull[28] !== null
                ? pallet.QualityFull[28]
                : ""
              : "")
        ),
        this.typedValue(
          pallet.AlienseedCount ||
            (pallet.QualityFull
              ? pallet.QualityFull[29] !== null
                ? pallet.QualityFull[29]
                : ""
              : "")
        ),
        this.typedValue(
          pallet.AlienseedContract ||
            (pallet.QualityFull
              ? pallet.QualityFull[30] !== null
                ? pallet.QualityFull[30]
                : ""
              : "")
        ),
        pallet.MiscData ||
          (pallet.QualityFull
            ? pallet.QualityFull[31] !== null
              ? pallet.QualityFull[31]
              : ""
            : ""),
        pallet.MiscSeed ||
          (pallet.QualityFull
            ? pallet.QualityFull[32] !== null
              ? pallet.QualityFull[32]
              : ""
            : ""),
        pallet.MiscTitle ||
          (pallet.QualityFull
            ? pallet.QualityFull[33] !== null
              ? pallet.QualityFull[33]
              : ""
            : ""),
        this.typedValue(
          pallet.QualityFull
            ? pallet.QualityFull[34] !== null
              ? pallet.QualityFull[34]
              : ""
            : ""
        ),
      ];

      if (store.showTerminated)
        row = row.concat([
          pallet.Terminated,
          configStore.palletstatuses[pallet.Status],
        ]);

      data.push(row);
    });
    //console.log(data, merges)

    var wb = XLSX.utils.book_new();
    var ws = XLSX.utils.aoa_to_sheet(data);
    ws["!merges"] = merges;
    XLSX.utils.book_append_sheet(wb, ws, "Táblázat");

    XLSX.writeFile(wb, "Táblázat_" + formatDateOnly(new Date()) + ".xlsx", {
      bookSST: true,
      compression: true,
    });
  };

  refresh = () => {
    const { store, socket } = this.props;
    const { showTerminated } = this.state;

    if (showTerminated && !store.from) {
      const date = new Date();
      date.setMonth(date.getMonth() - 3);
      store.setFrom(date);
    }

    const data = {
      From: store.from ? store.fromFormatted : null,
      To: store.to ? store.toFormatted : null,
      ShowTerminated: showTerminated,
    };

    const _this = this;
    socket.emitWithToken("GetMixedPallets", data, function (err, data) {
      if (err) {
        console.error(err);
        return;
      }
      store.setItems(data);
      _this.setState({ newContentAvailable: false });
    });
  };

  getPalletHistory = (palletid) => {
    const { store, socket } = this.props;

    const _palletid = palletid;

    socket.emitWithToken(
      "GetPalletHistory",
      { PalletId: _palletid },
      function (err, data) {
        if (err) {
          console.error(err);
          return;
        }
        store.setPalletHistory({ PalletId: _palletid, Data: data });
      }
    );
  };

  componentDidMount = () => {
    const { route, store, socket } = this.props;
    if (route.params.hasOwnProperty("search")) {
      store.setSearch(route.params.search);
    }

    socket.on("InventoryChanged", this.inventoryChanged);
  };

  componentWillUnmount = () => {
    this.props.socket.off("InventoryChanged", this.inventoryChanged);
  };

  inventoryChanged = (data) => {
    const { authStore } = this.props;
    if (data && data.UserId == authStore.user.Id) return;
    this.setState({ newContentAvailable: true });
  };

  showPopup = (text) => {
    this.setState({ popup: "show", popupText: text });
  };

  filterPallet = (pallet) => {
    const { store } = this.props;
    const item = pallet.ItemName + " " + (pallet.CustomItem || "");
    const machine = pallet.MachineText;
    const cleaningrate =
      pallet.CleaningRateText + " " + (pallet.CustomCleaningRate || "");
    store.setSearchText(item + " " + machine + " " + cleaningrate);
    store.setSearch(store.searchtext);
  };

  render() {
    const { store, configStore, authStore, route, router, socket } = this.props;
    const { shownItems, sortDirection, sortField, pager, uploading } = store;
    const { itemCount, lastShownItem, firstShownItem } = pager;
    let { name: routeName, params: routeParams } = route;
    const { showTerminated } = this.state;

    let rows = [];

    shownItems.forEach((pallet) => {
      let status;
      switch (pallet.Status) {
        case 1:
          status = "Feldolgozva";
          break;
        case 2:
          status = "Értékesítve";
          break;
        case 3:
          status = "Törölve";
          break;
      }

      rows.push(
        <tr
          key={pallet.Id}
          className="qualitytable__pallet-row"
          onClick={() => {
            store.resetCheckedPallets();
            this.filterPallet(pallet);
          }}
        >
          <td
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
            }}
          >
            <div
              className="table-checkbox-block"
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              <input
                id={"checkpallet" + pallet.Id}
                type="checkbox"
                name="checkedPallet"
                value="checkedPallet"
                checked={store.isChecked(pallet.Id)}
                onClick={(e) => {
                  store.setChecked(pallet.Id, !store.isChecked(pallet.Id));
                }}
              />
              <label htmlFor={"checkpallet" + pallet.Id}>
                <span></span>
              </label>
            </div>
          </td>
          <td>
            <div
              className="table_inrow_button"
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                store.setSelectedPallets([pallet.Id]);
                router.navigate(ROUTE_MIX);
              }}
            >
              Részletek
            </div>
          </td>

          <td>
            <span
              className={
                (pallet.CleaningCount > 1 ? "bold" : "normal") +
                (!pallet.ThisSeason ? " offseasonpallet" : "")
              }
            >
              {pallet.LotNo}
            </span>
            {pallet.SealNum ? <br /> : null}{" "}
            {pallet.SealNum ? "(" + pallet.SealNum + ")" : ""}
          </td>
          <td>{pallet.MachineText}</td>
          <td>{pallet.CleaningRateText}</td>
          <td>{pallet.Supplier}</td>
          <td>
            {pallet.ItemName} {pallet.CustomItem ? <br /> : null}{" "}
            {pallet.CustomItem ? "(" + pallet.CustomItem + ")" : ""}
          </td>
          <td>{pallet.BinCodeText}</td>
          <td>{pallet.QuantityText}</td>
          <td>{pallet.Created}</td>
          {showTerminated ? <td>{pallet.Terminated}</td> : null}
          {showTerminated ? <td>{status}</td> : null}
        </tr>
      );
    });

    return (
      <Frame>
        <div className="table basic-content">
          <div className="table__top">
            <div className="table-pager-amount">
              <PagerAmount
                perPage={pager.perPage}
                onChange={(e) => pager.setPerPage(e.value)}
              />
            </div>
            <div className="table-datepicker-block">
              Létrehozva&nbsp;
              <DatePicker
                className="table input-date form-input"
                dateFormat="yyyy-MM-dd"
                selected={store.from}
                onChange={(date) => {
                  store.setFrom(date);
                  this.refresh();
                }} /*locale='hu'*/
              />
              <div className="separator"></div>
              <DatePicker
                className="table input-date form-input"
                dateFormat="yyyy-MM-dd"
                selected={store.to}
                onChange={(date) => {
                  store.setTo(date);
                  this.refresh();
                }} /*locale='hu'*/
              />
            </div>
            <div className="table-checkbox-block">
              <input
                id="showTerminatedCheckbox"
                type="checkbox"
                name="showTerminated"
                value="showTerminated"
                checked={showTerminated}
                onClick={() => {
                  //store.changeShowTerminated();
                  const _this = this;
                  this.setState(
                    (prevState) => {
                      return { showTerminated: !prevState.showTerminated };
                    },
                    () => {
                      _this.refresh();
                    }
                  );
                }}
              />
              <label
                className="table-checkbox-label"
                htmlFor="showTerminatedCheckbox"
              >
                <span></span>
                <div className="table-checkbox-title">
                  Megszüntetettek mutatása
                </div>
              </label>
            </div>
            <TableSearch />
            <RefreshButton
              onClick={() => {
                this.refresh();
              }}
              newContentAvailable={this.state.newContentAvailable}
            />
          </div>
          <div className="table__content">
            <table>
              <thead>
                <tr>
                  <th className="table-header-checkbox">
                    <div
                      className="table-header-delete-button"
                      onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        store.resetCheckedPallets();
                      }}
                    >
                      X
                    </div>
                  </th>
                  <th>
                    <div
                      className={
                        "table_inrow_button " +
                        (store.checked.length > 0 ? "" : " disabled")
                      }
                      onClick={() => {
                        store.setSelectedPallets(store.checked);
                        router.navigate(ROUTE_MIX);
                      }}
                    >
                      Részletek
                    </div>
                  </th>

                  <th>
                    <div
                      className="table__header-cell"
                      onClick={this.onClickSort(SORT_LOTNO)}
                    >
                      Azonosító
                      <Sorter
                        activeDirection={
                          sortField === SORT_LOTNO ? sortDirection : null
                        }
                      />
                    </div>
                  </th>
                  <th>
                    <div
                      className="table__header-cell"
                      onClick={this.onClickSort(SORT_MACHINE)}
                    >
                      Gép
                      <Sorter
                        activeDirection={
                          sortField === SORT_MACHINE ? sortDirection : null
                        }
                      />
                    </div>
                  </th>
                  <th>
                    <div
                      className="table__header-cell"
                      onClick={this.onClickSort(SORT_CLEANINGRATE)}
                    >
                      Fok
                      <Sorter
                        activeDirection={
                          sortField === SORT_CLEANINGRATE ? sortDirection : null
                        }
                      />
                    </div>
                  </th>
                  <th>
                    <div
                      className="table__header-cell"
                      onClick={this.onClickSort(SORT_SUPPLIER)}
                    >
                      Beszállító
                      <Sorter
                        activeDirection={
                          sortField === SORT_SUPPLIER ? sortDirection : null
                        }
                      />
                    </div>
                  </th>
                  <th>
                    <div
                      className="table__header-cell"
                      onClick={this.onClickSort(SORT_ITEM)}
                    >
                      Cikk
                      <Sorter
                        activeDirection={
                          sortField === SORT_ITEM ? sortDirection : null
                        }
                      />
                    </div>
                  </th>
                  <th>
                    <div
                      className="table__header-cell"
                      onClick={this.onClickSort(SORT_LOCATION)}
                    >
                      Hely
                      <Sorter
                        activeDirection={
                          sortField === SORT_LOCATION ? sortDirection : null
                        }
                      />
                    </div>
                  </th>
                  <th>
                    <div
                      className="table__header-cell"
                      onClick={this.onClickSort(SORT_AMOUNT)}
                    >
                      Mennyiség
                      <Sorter
                        activeDirection={
                          sortField === SORT_AMOUNT ? sortDirection : null
                        }
                      />
                    </div>
                  </th>
                  <th>
                    <div
                      className="table__header-cell"
                      onClick={this.onClickSort(SORT_CREATED)}
                    >
                      Létrehozva
                      <Sorter
                        activeDirection={
                          sortField === SORT_CREATED ? sortDirection : null
                        }
                      />
                    </div>
                  </th>
                  {showTerminated ? (
                    <th>
                      <div
                        className="table__header-cell"
                        onClick={this.onClickSort(SORT_TERMINATED)}
                      >
                        Megszüntetve
                        <Sorter
                          activeDirection={
                            sortField === SORT_TERMINATED ? sortDirection : null
                          }
                        />
                      </div>
                    </th>
                  ) : null}
                  {showTerminated ? (
                    <th>
                      <div
                        className="table__header-cell"
                        onClick={this.onClickSort(SORT_STATUS)}
                      >
                        Művelet
                        <Sorter
                          activeDirection={
                            sortField === SORT_STATUS ? sortDirection : null
                          }
                        />
                      </div>
                    </th>
                  ) : null}
                </tr>
              </thead>
              <tbody className="table_body">{rows}</tbody>
            </table>
          </div>
          <div className="table__bottom">
            <div>
              {firstShownItem} - {lastShownItem} találat mutatása {itemCount}{" "}
              közül
            </div>
            <Pager
              routeName={routeName}
              routeParams={routeParams}
              pager={pager}
              onClickPage={(page) => pager.setCurrentPage(page)}
            />
          </div>
        </div>
        {this.state.popup === "none" ? null : (
          <Popup
            key="popup"
            text={this.state.popupText}
            onClickClose={() => this.setState({ popup: "none" })}
          />
        )}
      </Frame>
    );
  }
}

export {
  SORT_ASC,
  SORT_DESC,
  SORT_ID,
  SORT_MACHINE,
  SORT_CLEANINGRATE,
  SORT_SUPPLIER,
  SORT_LOTNO,
  SORT_AMOUNT,
  SORT_CREATED,
  SORT_TERMINATED,
  SORT_STATUS,
  SORT_LOCATION,
  SORT_ITEM,
  SORT_QPURITY,
  SORT_QALIENSEED,
  SORT_QHARDSEED,
  SORT_QGERM,
  SORT_QWATER,
};

export default (props) => (
  <RouteNode nodeName={ROUTE_MIXES}>
    {(routeProps) => <Mixes {...routeProps} {...props} />}
  </RouteNode>
);
